export const leaveRequestViewModalStyles = {
  container: {
    p: 0,
  },
  card: {
    m: 0,
    p: 3,
    borderRadius: 2,
    bgcolor: 'background.paper',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
    border: '1px solid',
    borderColor: 'divider',
  },
  header: {
    mb: 2,
  },
  title: {
    fontWeight: 600,
    mb: 0.25,
  },
  divider: {
    my: 1.5,
  },
  detailsContainer: {
    mt: 2,
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    mb: 2,
  },
  detailRowWithDescription: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    mb: 2,
  },
  label: {
    fontWeight: 600,
    color: 'text.secondary',
    mb: 0.5,
  },
  value: {
    color: 'text.primary',
    wordBreak: 'break-word',
  },
  descriptionValue: {
    color: 'text.primary',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    p: 1.25,
    bgcolor: 'grey.50',
    borderRadius: 1.5,
    border: '1px solid',
    borderColor: 'grey.200',
  },
};

